import React from "react";
import { useTranslation } from "react-i18next";
import {
  AboutSection,
  AboutContent,
  ImageWrapper,
  AboutImage,
  TextWrapper,
  Title,
  Description,
  CTAButton,
  Subtitle,
  Rank,
  TextContent,
} from "./AboutMe.styled";

import { Trans } from "react-i18next";
import aboutMeImage from "../../Assets/images/about-me.jpg";
import { Container } from "react-bootstrap";

const AboutMe = ({ onCTAClick, showButton = true, id = "about-me" }) => {
  const { t } = useTranslation();

  const handleCTAClick = () => {
    if (onCTAClick) {
      onCTAClick("contact");
    }
  };

  return (
    <AboutSection id={id}>
      <Container>
        <AboutContent>
          <ImageWrapper>
            <AboutImage
              src={aboutMeImage}
              alt={t("about.imageAlt")}
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          </ImageWrapper>

          <TextWrapper>
            <TextContent>
              <Subtitle>{t("about.subtitle")}</Subtitle>
              <Title>{t("about.title")}</Title>
              <Rank>{t("about.rank")}</Rank>
            </TextContent>
            <Description>
              <Trans>{t("about.description1")}</Trans>
            </Description>

            {showButton && (
              <CTAButton onClick={handleCTAClick}>
                {t("about.ctaButton")}
              </CTAButton>
            )}
          </TextWrapper>
        </AboutContent>
      </Container>
    </AboutSection>
  );
};

AboutMe.defaultProps = {
  onCTAClick: () => {},
  showButton: true,
  id: "about-me",
};

export default AboutMe;
